const SelfServeBuilderEnum = {
  SELF_SERVE_BUILDER_SET_PAGES_FROM_FILE: 'SELF_SERVE_BUILDER_SET_PAGES_FROM_FILE',
  SELF_SERVE_BUILDER_CURRENT_PAGE_SET: 'SELF_SERVE_BUILDER_CURRENT_PAGE_SET',
  SELF_SERVE_BUILDER_PAGINATION_CURRENT_PAGE_SET: 'SELF_SERVE_BUILDER_PAGINATION_CURRENT_PAGE_SET',
  SELF_SERVE_BUILDER_PAGINATION_NEXT: 'SELF_SERVE_BUILDER_PAGINATION_NEXT',
  SELF_SERVE_BUILDER_PAGINATION_BACK: 'SELF_SERVE_BUILDER_PAGINATION_BACK',
  SELF_SERVE_BUILDER_WAYPOINTS_DISABLE: 'SELF_SERVE_BUILDER_WAYPOINTS_DISABLE',
  SELF_SERVE_BUILDER_WAYPOINTS_ENABLE: 'SELF_SERVE_BUILDER_WAYPOINTS_ENABLE',
  SELF_SERVE_BUILDER_POPUP_CREATION_ENABLED_SET: 'SELF_SERVE_BUILDER_POPUP_CREATION_ENABLED_SET',
  SELF_SERVE_BUILDER_POPUP_CREATION_ATTEMPT_SET: 'SELF_SERVE_BUILDER_POPUP_CREATION_ATTEMPT_SET',
  SELF_SERVE_BUILDER_CUSTOM_TEMPLATE_DATA_GET_REQUEST: 'SELF_SERVE_BUILDER_CUSTOM_TEMPLATE_DATA_GET_REQUEST',
  SELF_SERVE_BUILDER_CUSTOM_TEMPLATE_DATA_GET_SUCCESS: 'SELF_SERVE_BUILDER_CUSTOM_TEMPLATE_DATA_GET_SUCCESS',
  SELF_SERVE_BUILDER_CUSTOM_TEMPLATE_DATA_GET_FAILURE: 'SELF_SERVE_BUILDER_CUSTOM_TEMPLATE_DATA_GET_FAILURE',
  SELF_SERVE_BUILDER_SCALING_MODE_SET: 'SELF_SERVE_BUILDER_SCALING_MODE_SET',
  SELF_SERVE_BUILDER_LOADING_START: 'SELF_SERVE_BUILDER_LOADING_START',
  SELF_SERVE_BUILDER_LOADING_DONE: 'SELF_SERVE_BUILDER_LOADING_DONE',
  SELF_SERVE_BUILDER_RECIPIENT_PREVIEW_MODAL_SET: 'SELF_SERVE_BUILDER_RECIPIENT_PREVIEW_MODAL_SET',
  SELF_SERVE_BUILDER_NOTIFICATION_SET: 'SELF_SERVE_BUILDER_NOTIFICATION_SET',
  SELF_SERVE_BUILDER_ZERO_STATE_SET: 'SELF_SERVE_BUILDER_ZERO_STATE_SET',
  SELF_SERVE_BUILDER_SAMPLE_STATE_SET: 'SELF_SERVE_BUILDER_SAMPLE_STATE_SET',
  SELF_SERVE_BUILDER_SAMPLE_STATE_FIRST_POPUP_MOUNTED: 'SELF_SERVE_BUILDER_SAMPLE_STATE_FIRST_POPUP_MOUNTED',
  SELF_SERVE_BUILDER_SAMPLE_DOCUMENT_RENTAL: 'SELF_SERVE_BUILDER_SAMPLE_DOCUMENT_RENTAL',
  SELF_SERVE_BUILDER_SAMPLE_DOCUMENT_NDA: 'SELF_SERVE_BUILDER_SAMPLE_DOCUMENT_NDA',
  SELF_SERVE_BUILDER_SAMPLE_DOCUMENT_CONTRACT: 'SELF_SERVE_BUILDER_SAMPLE_DOCUMENT_CONTRACT',
  SELF_SERVE_BUILDER_SAMPLE_DOCUMENT_CREATE_SUCCESS: 'SELF_SERVE_BUILDER_SAMPLE_DOCUMENT_CREATE_SUCCESS',
  SELF_SERVE_BUILDER_SAMPLE_DOCUMENT_CREATE_FAILURE: 'SELF_SERVE_BUILDER_SAMPLE_DOCUMENT_CREATE_FAILURE',
  SELF_SERVE_BUILDER_FIRST_POPUP_CREATED: 'SELF_SERVE_BUILDER_FIRST_POPUP_CREATED',
};

export const SAMPLE_DOCUMENT_TYPES = [
  SelfServeBuilderEnum.SELF_SERVE_BUILDER_SAMPLE_DOCUMENT_RENTAL,
  SelfServeBuilderEnum.SELF_SERVE_BUILDER_SAMPLE_DOCUMENT_NDA,
  SelfServeBuilderEnum.SELF_SERVE_BUILDER_SAMPLE_DOCUMENT_CONTRACT,
];
export default SelfServeBuilderEnum;



// WEBPACK FOOTER //
// ./src-react/SelfServeBuilder/SelfServeBuilderConstants.jsx